import React, { useEffect } from 'react';

import { Box } from '@material-ui/core';

import {
    useReservationRequestsLoad,
    useReservationsRestaurantId,
} from 'components/reservations/hooks';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { theme } from 'config/theme';
import { useAppSelector } from 'index';
import { ReservationDTO } from 'api/controllers/reservations';
import { SignalREvent, signalRService } from 'services/signalR';
import reservationsStore from 'store/reservationsStore';
import { useStyles } from '../styles';
import { useNavigationCounterLayout } from '../useNavigationCounterLayout';

export default function ReservationRequestsCounter(props: { isOpen: boolean }) {
    const classes = useStyles();
    const dispatch = useThunkDispatch();
    const restaurantId = useReservationsRestaurantId();
    const isLoaded = useAppSelector(
        (state) => restaurantId !== null && state.reservations.requestsRestaurantId === restaurantId
    );
    const count = useAppSelector((state) => state.reservations.requests.length);
    const { left, width } = useNavigationCounterLayout({
        isOpen: props.isOpen,
        count,
        openLeft: { en: 160, other: 175 },
    });
    useReservationRequestsLoad();

    useEffect(() => {
        if (!restaurantId) {
            return;
        }
        const handleReservationChange = (reservation: ReservationDTO) => {
            if (reservation.restaurantId === restaurantId) {
                dispatch(reservationsStore.actionCreators.applyRealtimeUpdate(reservation));
            }
        };
        const unsubscribeAdded = signalRService.subscribe(
            SignalREvent.ReservationAdded,
            handleReservationChange
        );
        const unsubscribeChanged = signalRService.subscribe(
            SignalREvent.ReservationChanged,
            handleReservationChange
        );
        return () => {
            unsubscribeAdded();
            unsubscribeChanged();
        };
    }, [restaurantId]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!isLoaded || count === 0) {
        return null;
    }

    return (
        <Box position="relative">
            <Box
                className={classes.newOrdersCount}
                left={left}
                width={width}
                style={{ backgroundColor: theme.palette.error.light }}
            >
                {count}
            </Box>
        </Box>
    );
}
